import React from 'react'
import { connect } from 'react-redux'
import { get, max, range, findIndex, omit, keys } from 'lodash'
import Dimensions from 'react-dimensions'
import { Origin } from 'redux-tooltip';
import './index.css'

var d3 = require('d3')
const Ocircle = Origin.wrapBy('circle')

const makeTrend = (indicatorData, years, dataByCountry, numYears, containerWidth, height, margin) => {

  const plotData = years.map(year => {
    return dataByCountry && dataByCountry[year] ? {
      year,
      ...dataByCountry[year]
    } : null
  })

  const yearWidth = (containerWidth - (margin * 2)) / numYears;
  //SCALE direction depends on indicator "rankDirection"
  let rangeForIndicator;
  if(indicatorData.rankDirection === "1"){
    rangeForIndicator = [margin, height-(margin*2)]
  } else {
    rangeForIndicator = [height-(margin*2), margin]
  }

  const scale = d3.scaleLinear().domain(indicatorData.domain).range(rangeForIndicator)
  const trendLines = plotData.reduce((accumulator, currentValue, currentIndex)=>{
    if(currentIndex === plotData.length){
      return accumulator
    }
    if(currentValue !== null){
      const nextIndex = findIndex(plotData, (item, i) => (i > currentIndex && item))
      if(nextIndex !== -1){
        accumulator.push({
          x1: margin+currentIndex*yearWidth, y1:scale(currentValue.v),
          x2: margin+nextIndex*yearWidth, y2:scale(plotData[nextIndex].v),
          virtual : nextIndex > currentIndex + 1
        })
      }
    }
    return accumulator
  }, [])

  return { plotData, trendLines, yearWidth, scale }

}


class TrendChart extends React.PureComponent {
  render() {

    //const { dataByCountry, countryCode, indicatorData, height=50, numYears=7, containerWidth } = this.props
    const {
        countries, indicatorData,
        height=50, containerWidth, showScores=true,
        numYears=7,
        countryCode, dataByCountry, comparisonCountryCode=null, comparisonDataByCountry=null } = this.props


    if(!indicatorData.domain){
      return null
    }


    let existingYearsCountry = keys(dataByCountry)
    let existingYearsComparisonCountry = keys(comparisonDataByCountry)

    let existingYears = existingYearsCountry.length ? existingYearsCountry : existingYearsComparisonCountry.length ?  existingYearsComparisonCountry : [];
    let maxYearCountry = max(existingYearsCountry.map(i => parseInt(i, 10)))
    let maxYearComparisonCountry = max(existingYearsComparisonCountry.map(i => parseInt(i, 10)))

    let maxValueCountry = dataByCountry ? get(dataByCountry, `[${maxYearCountry}].v`) : null
    let maxValueComparisonCountry = comparisonDataByCountry ? get(comparisonDataByCountry, `[${maxYearComparisonCountry}].v`) : null

    const margin = 4;
    let maxYear, years;

    if(!existingYears.length){
      maxYear = 2016
    } else {
      maxYear = max(existingYears.map(i => parseInt(i, 10)))
    }
    years = range(maxYear-numYears+1, maxYear+1).map(i => i.toString())


    let comparisonPlotData=[], comparisonTrendLines=[]
    const { plotData, trendLines, yearWidth, scale } = makeTrend(indicatorData, years, dataByCountry, numYears, containerWidth, height,  margin)
    if(comparisonCountryCode && comparisonDataByCountry){
        const comparisonData = makeTrend(indicatorData, years, comparisonDataByCountry, numYears, containerWidth, height,  margin)
        comparisonPlotData = comparisonData.plotData
        comparisonTrendLines= comparisonData.trendLines
    }

    return (
      <svg height={height} className="TrendChart__svg">
        {/* grid */}
        <g>
          { years.map((year, i) => (
            i < years.length-1 && (
              <rect key={year} height={height- (margin*2)} width={yearWidth} x={margin+i*yearWidth} y={margin} className="rect-grid"/>
            )

          )) }

        </g>

        {/* trend line */}
        <g>
          { trendLines.map((trendLine, i) => {
            const lineAttrs = omit(trendLine, ['virtual'])
            return (
              <line key={i} {...lineAttrs} className={`trend-line ${trendLine.virtual ? 'virtual' : ''}`} />
            )
          })}
        </g>

        {/* comparison trend line if any */}
        { comparisonCountryCode && comparisonDataByCountry && (
          <g>
            { comparisonTrendLines.map((trendLine, i) => {
              const lineAttrs = omit(trendLine, ['virtual'])
              return (
                <line key={i} {...lineAttrs} className={`trend-line-comparison ${trendLine.virtual ? 'virtual' : ''}`} />
              )
            })}
          </g>

        )}

        {/* circles */}
        <g>
          {plotData.map((datum, i) => (
            datum && (
              <Ocircle
                key={i} r={3} cx={margin+i*yearWidth} cy={scale(datum.v)}
                className="circle-datum" content={`${countries[countryCode]}: ${datum.v} (${datum.year})`}/>
            )
          ))}
        </g>
        {/* comparison circles if any */}
        { comparisonCountryCode && comparisonDataByCountry && (
          <g>
          { comparisonPlotData.map((datum, i) => (
            datum && (
              <Ocircle
                key={i} r={3} cx={margin+i*yearWidth} cy={scale(datum.v)}
                className="circle-datum-comparison" content={`${countries[comparisonCountryCode]}: ${datum.v} (${datum.year})`}/>
            )
          ))}
          </g>
        )}

        {/* scores if needed */}
        { showScores && (
          <g transform={`translate(${yearWidth * (numYears-1) + yearWidth/2 - margin * 2} ,0)`}>
            { maxValueCountry !== null && maxValueComparisonCountry === null && <g>
              <text y={height/2+margin} className="TrendChart__score_country">{maxValueCountry}</text>
            </g>}
            { maxValueCountry !== null && maxValueComparisonCountry !== null && <g>
              <text y={height/3+margin} className="TrendChart__score_country--multi">{maxValueCountry}</text>
              <text y={height/3*2+margin} className="TrendChart__score_comparison">{maxValueComparisonCountry}</text>
            </g>}
          </g>

        ) }
      </svg>
    )
  }
}


const mapStateToProps = (state, props) => ({
  //dataByCountry : getTrendDataByCountryAndIndicator(state, props),
  //indicators: state.indicators,
  countries: state.countries,
})

export default connect(mapStateToProps)(Dimensions()(TrendChart))



// WEBPACK FOOTER //
// ./src/components/TrendChart/index.js